var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7855 21.5591V15.8886C37.7855 11.6067 34.282 8.10316 30 8.10316C25.718 8.10316 22.2145 11.6066 22.2145 15.8886V21.5591H15.9863V15.8888C15.9863 8.18121 22.2925 1.875 30 1.875C37.7076 1.875 44.0138 8.18121 44.0138 15.8888V21.5591H37.7855ZM51.7234 29.3568V53.257C51.7234 55.9344 49.5328 58.125 46.8554 58.125H13.1446C10.4672 58.125 8.27661 55.9344 8.27661 53.257V29.3566C8.27661 26.6793 10.4672 24.4887 13.1446 24.4887H46.8554C49.5328 24.4887 51.7234 26.6794 51.7234 29.3568ZM34.0938 37.5705C34.0938 35.3096 32.261 33.4767 30 33.4767C27.739 33.4767 25.9062 35.3096 25.9062 37.5705C25.9062 38.9617 26.6003 40.1905 27.6607 40.9303V46.798C27.6607 48.0847 28.7133 49.1373 30 49.1373C31.2867 49.1373 32.3393 48.0846 32.3393 46.798V40.9302C33.3999 40.1904 34.0938 38.9616 34.0938 37.5705Z",
    fill: "url(#paint0_linear_119_96)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_119_96",
    x1: 30,
    y1: 58.1249,
    x2: 30,
    y2: 1.87488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A5298"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockicon);
export default __webpack_public_path__ + "static/media/lockicon.64b8e6ac00b5a257a6959e13fbc7e237.svg";
export { ForwardRef as ReactComponent };